import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { UploadPhotoUseCaseInterface } from 'domain/usecases';

export class RemoteUploadPhoto implements UploadPhotoUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<UploadPhotoUseCaseInterface.Result>,
  ) {}

  async execute(
    params: UploadPhotoUseCaseInterface.Params,
  ): Promise<UploadPhotoUseCaseInterface.Result> {
    const { photo } = params;
    const httpResponse = await this.httpClient.request({
      method: 'patch',
      url: this.url + '/' + params.id,
      body: { photo },
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
